module.exports = __webpack_public_path__ + "img/dori_Kalsiy_D3-2.60e2f5c1.jpg";